import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3h397zd1p8: FaireBrandEntity = {
  token: "b_3h397zd1p8",
  type: "brand",
  name: "Pyramid America",
  avatarUrl:
    "https://cdn.faire.com/fastly/64f5884a45c358dd2c2ffae16ae2c26874d2302c01263b1e29623629ec32e4f9.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/bff2d1d8dd48ebba5540c362f77003e6c210647622255c1d7ec423a7a7948009.png",
  logoUrl:
    "https://cdn.faire.com/fastly/64f5884a45c358dd2c2ffae16ae2c26874d2302c01263b1e29623629ec32e4f9.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/bff2d1d8dd48ebba5540c362f77003e6c210647622255c1d7ec423a7a7948009.png",
  location: "Mt Vernon, NY, USA",
  minimumOrderDollars: 207,
  rating: 4.9,
  reviewCount: 183,
  isTopShop: true,
  isInsider: true,
  description:
    "Pyramid America – Your First Choice For Cool Licensed Merch! Our obsession: bringing the very best in branded merchandise to the masses through our vast partner network of retailers, not just in the US, but across the globe. Our unrivaled range of unique products extends to posters, wall art, stationery, hydration, gifting, homeware, accessories, and beyond. Always leading. Always listening. Always awesome.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:35:48.452Z",
    importedBy: "entity-db-cli",
  },
};
